<div class="name">{{state.dragData?.el?.name}}</div>
